import React from 'react';
import styles from './index.module.css';

export const StepStatus = ({ currentStep, totalSteps, langText }) => (
  <div className={styles.stepStatus}>{`${(langText?.step || 'Step')} ${currentStep} ${(langText?.of || 'of')} ${totalSteps}`}</div>
);
